/* @ngInject */
function eventListenerService () {
  const removableListeners = []
  const permanentListeners = []
  const service = {
    deleteEventListener,
    registerEventListener,
    clearRemovableListeners,
    removableListeners,
    permanentListeners
  }

  return service

  function registerEventListener (id, element, type, options, callback) {
    const listener = {
      type: type,
      callback: callback,
      element: element
    }

    if (options.substitute) {
      if (removableListeners[id]) {
        deleteEventListener(id)
      }
      element.addEventListener(type, callback)
      removableListeners[id] = listener
    } else {
      if (!permanentListeners[id]) {
        element.addEventListener(type, callback)
        permanentListeners[id] = listener
      }
    }
  }

  function deleteEventListener (id) {
    if (removableListeners[id]) {
      removableListeners[id].element.removeEventListener(
        removableListeners[id].type,
        removableListeners[id].callback
      )
      removableListeners[id] = undefined
    }
  }

  function clearRemovableListeners () {
    for (const key in removableListeners) {
      deleteEventListener(key)
    }
  }
}

export { eventListenerService }
